import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Card } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { useSelectedAirline } from "../../../hooks/useSelectedAirline";
import { ChartErrorBoundary } from "../ChartErrorBoundary";
import { ChartSuspense } from "../ChartSuspense";
import { SearchCoverageChartLoader, type SearchCoverageChartLoaderProps } from "./SearchCoverageChartLoader";

export const SearchCoverageChartCard = (props: SearchCoverageChartLoaderProps) => {
  const i18n = useI18n();
  const { selectedAirline } = useSelectedAirline();

  return (
    <Card mixin={{ paddingBlockStart: 6, paddingInlineStart: 6 }}>
      <div className="apexcharts-container">
        <ErrorBoundary
          resetKeys={[props.from, props.to, selectedAirline?.code]}
          fallback={
            <ChartErrorBoundary
              titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_three_name"))}
            />
          }
        >
          <Suspense
            fallback={
              <ChartSuspense
                titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_three_name"))}
              />
            }
          >
            <SearchCoverageChartLoader {...props} />
          </Suspense>
        </ErrorBoundary>
      </div>
    </Card>
  );
};
